export var CITIZENSHIP_CITIZEN = 'citizen';
export var CITIZENSHIP_RESIDENT = 'resident';
export var CITIZENSHIP_OTHER = 'other'; // TODO unused?

export var CITIZENSHIP = [CITIZENSHIP_CITIZEN, CITIZENSHIP_RESIDENT, CITIZENSHIP_OTHER];
export var EMPLOYMENT_FULLTIME = 'FULL_TIME';
export var EMPLOYMENT_PARTTIME = 'PART_TIME';
export var EMPLOYMENT_SELF_EMPLOYED = 'SELF_EMPLOYED';
export var EMPLOYMENT_MILITARY = 'MILITARY';
export var EMPLOYMENT_RETIRED = 'RETIRED';
export var EMPLOYMENT_UNEMPLOYED = 'UNEMPLOYED';
export var EMPLOYMENT_OTHER = 'OTHER';
export var EMPLOYMENT = [EMPLOYMENT_FULLTIME, EMPLOYMENT_PARTTIME, EMPLOYMENT_SELF_EMPLOYED, EMPLOYMENT_MILITARY, EMPLOYMENT_RETIRED, EMPLOYMENT_UNEMPLOYED, EMPLOYMENT_OTHER]; // TODO standardize, document move to home-constants or mortgage-utils
// TU Constants

export var TU_ACCOUNT_OPEN = 'Open';
export var TU_ACCOUNT_SUBTYPE_SYMBOL_TO_LOAN_TYPE_FHA = 'FR'; // FHA Real Estate Mortgage

export var TU_ACCOUNT_SUBTYPE_SYMBOL_TO_LOAN_TYPE_VA = 'VM'; // V.A. Real Estate Mortgage

export var TU_ACCOUNT_SUBTYPE_SYMBOL_TO_LOAN_TYPE_USDA = 'FL'; // FMHA Real Estate Mortgage

export var TU_ACCOUNT_TYPE_MORTGAGE = 'Mortgage';
export * from '@nerdwallet/home-constants';